import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import {
    FETCH_SCHEDULAR_DAY,
    SCHEDULAR_DAY_EDIT,
    FETCH_SCHEDULAR_EXPIRE_TIME,
    SCHEDULAR_EXPIRE_TIME_EDIT,
    GET_SESSIONS,
} from "constants/schedular.constants";
import {
    getSchedularSuccess,
    getSchedularExpireTimeSuccess,
    getSessionsSuccess,
  } from "actions/schedular.action"
import axios from "axios";
import { showErrors, stopLoader, setNotification } from "actions/general.action";

//get number of days 
const fetchSchedulardaysRequest = async () => {
    let link = "/api/v1/super_admin/config";
    return axios.get(link);
  };
  
  function* fetchSchedularDays({  }) {
    try {
      const result = yield call(fetchSchedulardaysRequest);
      if (result.message) {
        yield put(showErrors(result.message));
      } else {
          
        yield put(getSchedularSuccess(result.data.data[4].value));
      }
    } catch (error) {
      yield put(showErrors(error.message));
    }
  }

 //update days
    const updateSchedulardayRequest = async (new_schedular_day) => {
   
    const schedularObject = {
          config_session_day: parseInt(new_schedular_day),
            };
    return axios.put("/api/v1/super_admin/config" ,schedularObject );
  };
  
  
  function* updateSchedulardays({ new_schedular_day }) {
    let notification = {
      open: true,
      status: "",
      message: "",
    };

    try {
      const result = yield call(updateSchedulardayRequest, new_schedular_day);
      
      if (result.message) {
        notification.status = "error";
        notification.message = "Request Failed";
        yield put(stopLoader());
      } else {
        notification.status = "success";
        notification.message = "Configuration Updated";
        yield all([
          put(getSchedularSuccess(result.data.data[4].value)),
          put(stopLoader("Configuration Updated"))
        ]);
      }
      yield put(setNotification(notification));
    }
    catch (error) {
      notification.status = "error";
      notification.message = error.message;
      yield put(stopLoader());
      yield put(setNotification(notification));
    }
  }

//get configuration expire time

const fetchSchedularexpireTimeRequest = async () => {
  let link = "/api/v1/super_admin/config";
  return axios.get(link);
};

function* fetchSchedularExpireTime({  }) {
  try {
    const result = yield call(fetchSchedularexpireTimeRequest);
    if (result.message) {
      yield put(showErrors(result.message));
    } else {
        
      yield put(getSchedularExpireTimeSuccess(result.data.data[5].value));
    }
  } catch (error) {
    yield put(showErrors(error.message));
  }
}


//update schedular expire time

const updateSchedularExpireTimeRequest = async (new_schedular_expire_time) => {
   
  const schedularExpireTimeObject = {
        config_consultation_expire_time: parseInt(new_schedular_expire_time),
          };
  return axios.put("/api/v1/super_admin/config" ,schedularExpireTimeObject );
};

function* updateSchedularExpireTime({ new_schedular_expire_time }) {
  let notification = {
    open: true,
    status: "",
    message: "",
  };

  try {
    const result = yield call(updateSchedularExpireTimeRequest, new_schedular_expire_time);
    
    if (result.message) {
      notification.status = "error";
      notification.message = "Request Failed";
      yield put(stopLoader());
    } else {
      notification.status = "success";
      notification.message = "Configuration Updated";
      yield all([
        put(getSchedularExpireTimeSuccess(result.data.data[5].value)),
        put(stopLoader("Configuration Updated"))
      ]);
    }
    yield put(setNotification(notification));
  }
  catch (error) {
    notification.status = "error";
    notification.message = error.message;
    yield put(stopLoader());
    yield put(setNotification(notification));
  }
}

const getSessionsRequest = async (payload) => {
  return axios.request({
      method: 'GET',
      url: `/api/v1/super_admin/sessions`,
      params: payload
  })
}

function* getSessions({ payload }) {
  try {
      const reuslt = yield call(getSessionsRequest, payload);

      if (reuslt.message) {
          yield put(showErrors(reuslt.message));
      } else {
          yield put(getSessionsSuccess(reuslt.data));
          yield put(stopLoader());
      }

  } catch (error) {
      yield put(showErrors(error.message));
  }
}

//schedular day

  export function* forkSchedulardays() {
    yield takeEvery(FETCH_SCHEDULAR_DAY, fetchSchedularDays);
  }

  export function* forkUpdateSchedularDay() {
    yield takeEvery(SCHEDULAR_DAY_EDIT, updateSchedulardays);
  }

//schedular expire

export function* forkSchedularexpireTime() {
  yield takeEvery(FETCH_SCHEDULAR_EXPIRE_TIME, fetchSchedularExpireTime);
}

export function* forkUpdateSchedularExpireTime() {
  yield takeEvery(SCHEDULAR_EXPIRE_TIME_EDIT, updateSchedularExpireTime);
}

export function* forkGetSessions() {
  yield takeEvery(GET_SESSIONS, getSessions);
}

export default function* rootSaga() {
    yield all([
      fork(forkSchedulardays), 
      fork(forkUpdateSchedularDay), 
      fork(forkSchedularexpireTime),
      fork(forkUpdateSchedularExpireTime),
      fork(forkGetSessions)
    ]);
  }